import { NotifyMessage } from '../../components/NotifyMessage';
import { MeetOpenChat } from './MeetOpenChat';

export function MeetActionButtons({
  backCard,
  backCardDisabled,
  skipCard,
  likeCard,
  superLikeCard,
  goToChatCard,
  likedMe,
  disabledButton,
  openChatNotifyCount,
  openChatNotifyMinCount,
  resetOpenChatNotifyCount
}) {
  return (
    <div className="flex items-center justify-between gap-1 shrink-0 mt-4">
      <div className="relative">
        <button
          className="relative disabled:opacity-50 group"
          onClick={backCard}
          disabled={backCardDisabled || disabledButton}
        >
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.75" y="0.75" width="46.5" height="46.5" rx="23.25" fill="black" fill-opacity="0.3" />
            <rect
              x="0.75"
              y="0.75"
              width="46.5"
              height="46.5"
              rx="23.25"
              stroke="white"
              className="group-hover:stroke-[#A1F69E]"
              stroke-width="1.5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.1154 17.1453C22.1154 16.7986 21.9066 16.486 21.5863 16.3534C21.266 16.2207 20.8973 16.294 20.6522 16.5392L17.9104 19.2809C17.5757 19.6156 17.5757 20.1584 17.9104 20.4931L20.6522 23.2348C20.8973 23.48 21.266 23.5533 21.5863 23.4206C21.9066 23.288 22.1154 22.9754 22.1154 22.6287V21.0297H24C26.3972 21.0297 28.3407 22.9731 28.3407 25.3704C28.3407 27.7676 26.3972 29.711 24 29.711C21.6027 29.711 19.6594 27.7676 19.6594 25.3704C19.6594 24.7392 19.1477 24.2275 18.5165 24.2275C17.8853 24.2275 17.3737 24.7392 17.3737 25.3704C17.3737 29.03 20.3404 31.9967 24 31.9967C27.6596 31.9967 30.6264 29.03 30.6264 25.3704C30.6264 21.7107 27.6596 18.744 24 18.744H22.1154V17.1453Z"
              fill="white"
              className="group-hover:fill-[#A1F69E]"
            />
          </svg>
        </button>

        {likedMe && (
          <NotifyMessage className="left-0 w-[180px]" showMode={true} arrowPosition="left">
            <p>
              УПС! Вы упустили симпатию!
              <span className="text-[#A1F69E]"> Вернитесь назад</span>
            </p>
          </NotifyMessage>
        )}
      </div>

      <button className="group disabled:opacity-50" id="9voirhqihmd" onClick={skipCard} disabled={disabledButton}>
        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect
            x="0.679688"
            y="0.679688"
            width="56.6406"
            height="56.6406"
            rx="28.3203"
            fill="black"
            fill-opacity="0.3"
          />
          <rect
            x="0.679688"
            y="0.679688"
            width="56.6406"
            height="56.6406"
            rx="28.3203"
            stroke="white"
            stroke-width="1.35938"
            className="group-hover:stroke-[#CE5D49]"
          />
          <g clip-path="url(#clip0_383_4539)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.1476 20.3167C21.642 19.8111 20.8223 19.8111 20.3167 20.3167C19.8111 20.8223 19.8111 21.642 20.3167 22.1476L27.1691 29L20.3167 35.8524C19.8111 36.358 19.8111 37.1777 20.3167 37.6833C20.8223 38.1889 21.642 38.1889 22.1476 37.6833L29 30.8309L35.8524 37.6833C36.358 38.1889 37.1777 38.1889 37.6833 37.6833C38.1889 37.1777 38.1889 36.358 37.6833 35.8524L30.8309 29L37.6833 22.1476C38.1889 21.642 38.1889 20.8223 37.6833 20.3167C37.1777 19.8111 36.358 19.8111 35.8524 20.3167L29 27.1691L22.1476 20.3167Z"
              fill="white"
              className="group-hover:fill-[#CE5D49]"
            />
          </g>
          <defs>
            <clipPath id="clip0_383_4539">
              <rect width="18.125" height="18.125" fill="white" transform="translate(19.9375 19.9375)" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <button className="disabled:opacity-50" id="p671hvsgvl" onClick={superLikeCard} disabled={disabledButton}>
        <img src="/icons/photo_overlay_button_3.svg" alt="Супер лайк" className="w-[64px] h-[64px]" />
      </button>
      <button
        className="relative group disabled:opacity-50"
        id="9voirhqihmd"
        onClick={likeCard}
        disabled={disabledButton}
      >
        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect
            x="0.679688"
            y="0.679688"
            width="56.6406"
            height="56.6406"
            rx="28.3203"
            fill="black"
            fill-opacity="0.3"
          />
          <rect
            x="0.679688"
            y="0.679688"
            width="56.6406"
            height="56.6406"
            rx="28.3203"
            stroke="white"
            stroke-width="1.35938"
            className="group-hover:stroke-[#A1F69E]"
          />
          <g clip-path="url(#clip0_383_4549)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.3762 19.8104C25.8996 19.9208 27.4869 20.6633 29.0063 22.1662C30.5254 20.6637 32.1113 19.9226 33.6332 19.8147C35.3508 19.6928 36.8693 20.3871 37.968 21.4823C40.1279 23.6358 40.8062 27.5325 38.126 30.2128C38.117 30.2218 38.1076 30.2307 38.0982 30.2392L29.5278 38.0023C29.2318 38.2703 28.7808 38.2703 28.4848 38.0023L19.9144 30.2392C19.905 30.2307 19.8957 30.2218 19.8867 30.2128C17.1924 27.5185 17.8671 23.6214 20.0342 21.4696C21.1355 20.376 22.657 19.6858 24.3762 19.8104Z"
              fill="white"
              className="group-hover:fill-[#A1F69E]"
            />
          </g>
          <defs>
            <clipPath id="clip0_383_4549">
              <rect width="21.75" height="21.75" fill="white" transform="translate(18.125 18.125)" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <MeetOpenChat
        recipientId={goToChatCard()}
        count={openChatNotifyCount}
        minCount={openChatNotifyMinCount}
        resetCount={resetOpenChatNotifyCount}
      />
    </div>
  );
}
